<template>
<div class="container">
  <div class="center">

    <div v-if="noData" class="no-data">
      <p class="text">No Account</p>
      <div class="add-btn" @click="addAccount">
        <p>Add Account</p>
      </div>
    </div>

    <div v-else class="account-list">
      <div class="tool-bar">
        <div class="add-btn" @click="addAccount">
          <p>Add Account</p>
        </div>

        <div class="del-btn" @click="deleteAccount">
          <p>Delete</p>
        </div>
        <div style="clear: both"></div>
      </div>

      <div class="table-wrap">
        <table>
          <tr class="table-head">
            <td class="col1" width="15%">
              <input type="checkbox" @click="chooseAll" v-model="checked"/>
              <span>Account</span>
            </td>
            <td>
              EasyPatch
            </td>
            <td>
              HCP
            </td>
            <td>
              SW upgrade
            </td>
            <td>
              HCL-PDM
            </td>
            <td>
              HCL-EasyPatch
            </td>
           <td>
             EasyUpdate
           </td>
           <td>
             User
           </td>
           <td>
            Agency
           </td>
          </tr>

          <tr v-for="(item, index) in accounts" class="data-row" :class="{'even': (index)%2 }">
            <td class="col1">
              <input type="checkbox"  v-model="item.check"/>
              <span>{{item.account}}</span>
            </td>
            <td class="col2" v-for="key in ['EasyPatchLogin',  'HCPCreate', 'FirmwareUpdateConfig', 'HCLConfig','HCLConfigForEasyPatch','EasyUpdateLogin','UserAdmin','Agency']">
              <img v-if="item.permission[key]" src="/static/accountadmin/icon_selected.png"/>
            </td>

          </tr>
        </table>
      </div>
    </div>
  </div>
</div> <!--container结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default {
    data() {
      return {
        'noData':true,
        checked:false,
        accounts:[
        ]
      }
    },
    computed:{

    },
    watch:{

    },
    mounted(){
      this.loadData()
    },
    methods: {
      loadData() {
        this.$http.post('/api/v2.1/account_manage/get_record', {
          permission:'AccountAdmin'
        }).then(function (res) {
          let accountData = res.body.data;
          if (accountData && accountData.length>0) {
            this.noData=false;
            this.accounts=accountData;
          } else {
            this.noData=true;
            this.accounts=[];
          }
        }, function (err) {

        })
      },
      addAccount() {
        this.$router.push('/accountsadmin_super_add')
      },
      deleteAccount() {
        let accounts=[];
        accounts = this.accounts.filter(function (e,i) {
          return e.check;
        })
        accounts = accounts.map(function (e,i) {
          return e.account;
        })
        this.$http.post('/api/v2.1/account_manage/delete', {
          accounts:accounts,
          permission: 'AccountAdmin'
        }).then(function (res) {
          let error = res.body.error;
          if (error) {
            this.$message.error('code:'+error);
          } else {
            this.$message({
              type:'success',
              message:"Success"
            })
            // this.reload()
            this.loadData()
          }
        }, function (err) {
          
        })
      },
      chooseAll () {
        if(!this.checked){
          for(let i=0; i<this.accounts.length;i++){
            this.accounts[i].check = false
          }
        } else {
          for(let i=0; i<this.accounts.length;i++){
            this.accounts[i].check = true
          }
        }
      }
    },
  }
</script>

<style scoped>
  .container {
    height:100%;
    background-color:#ffffff;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .container .center .no-data {
    padding-top: 5%;
  }

  .container .center .no-data .text {
    text-align: center;
    font-size:20px;
    *margin-top: 20%;
  }

  .container .center .add-btn {
    width:150px;
    background-color:#0c544f;
    height:30px;
    border-radius:20px;
    margin: 0 auto;
    margin-top:50px;
    cursor: pointer;
  }

  .container .center .add-btn {
    color: #fff;
    text-align: center;
    line-height: 30px;
  }

  .container .center .account-list .tool-bar {
    padding-top: 20px;
  }

  .container .center .account-list .tool-bar .add-btn {
    margin: 0;
    float:right;
  }

  .container .center .account-list .tool-bar .del-btn {
    width:100px;
    background-color:#c03c13;
    height:30px;
    border-radius:20px;
    cursor: pointer;
    float:right;
    margin-right:50px;
  }

  .container .center .account-list .tool-bar .del-btn p {
    text-align: center;
    color:#fff;
    line-height: 30px;

  }

  .account-list .table-head {
    background-color:#0c544f;
    height:40px;
    color:#fff;
  }

  .table-wrap table .data-row {
    height:40px;
  }

  .table-wrap table .data-row.even {
    background-color:#e7e7e7;
  }

  .account-list .table-wrap {
    margin-top:30px;

  }

  .account-list .table-wrap table {
    width: 100%;
    border-collapse:collapse;
    border:none;
  }

  .table-wrap table input[type="checkbox"] {
    width: 18px;
    height: 18px;
    /*background-color: red;*/
    /*-webkit-appearance:none;*/
    border: 1px solid #c9c9c9;
    border-radius: 2px;
    outline: none;
    margin-left: 10px;
    margin-top:5px;
    float: left;
  }

  .table-wrap table .col1 span {
    float: left;
    margin-left: 10px;
    margin-top: 2px;
  }

  .table-wrap table .col2 {
    padding-left: 15px;
  }

  .table-wrap table input[type="checkbox"]:checked {
    /*background: url("/static/accountadmin/icon_selected.png") no-repeat center;*/
  }



</style>



// WEBPACK FOOTER //
// AccountAdminSuper.vue?8b1c40c2